/**
 * we initialize it at app level only once
 */

export class ComponentContextStore {
  // this value hold global context of all components we provide it to via ComponentStore
  componentGlobalSore: { [name: string]: any } = {};
}
